import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import uniqBy from 'lodash.uniqby';
import { ProviderLabel } from './types.js';
import standardWallets from './wallets.js';
import { validateWalletOptions } from './validation.js';
import { defaultWalletUnavailableMsg, isWalletAvailable } from './helpers.js';
export { ProviderIdentityFlag, ProviderLabel } from './types.js';
function injected(options) {
  if (typeof window === 'undefined') return function () {
    return null;
  };
  if (options) {
    var result = validateWalletOptions(options);
    if (result && result.error) throw result.error;
  }
  return function (helpers) {
    var device = helpers.device;
    var _ref = options || {},
      _ref$custom = _ref.custom,
      custom = _ref$custom === void 0 ? [] : _ref$custom,
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? {} : _ref$filter,
      displayUnavailable = _ref.displayUnavailable,
      sort = _ref.sort,
      walletUnavailableMessage = _ref.walletUnavailableMessage;
    // combine custom with standard wallets and dedupe
    var allWallets = uniqBy([].concat(_toConsumableArray(custom), _toConsumableArray(standardWallets)), function (_ref2) {
      var label = _ref2.label;
      return label;
    });
    var wallets = allWallets.reduce(function (acc, wallet) {
      var label = wallet.label,
        platforms = wallet.platforms,
        injectedNamespace = wallet.injectedNamespace,
        checkProviderIdentity = wallet.checkProviderIdentity;
      var walletFilters = filter[label];
      var filteredWallet = walletFilters === false;
      var provider = window[injectedNamespace];
      var walletAvailable = isWalletAvailable(provider, checkProviderIdentity, device);
      var excludedDevice = false;
      // dev specified platform filters
      if (Array.isArray(walletFilters) && (walletFilters.includes(device.type) || walletFilters.includes(device.os.name))) {
        excludedDevice = true;
      }
      // unavailable filter
      if (walletFilters === 'unavailable' && !walletAvailable) {
        excludedDevice = true;
      }
      // wallet specified platform filters
      var invalidPlatform = !platforms.includes('all') && !platforms.includes(device.type) && !platforms.includes(device.os.name);
      var supportedWallet = !filteredWallet && !excludedDevice && !invalidPlatform && (walletAvailable || displayUnavailable);
      if (supportedWallet) {
        acc.push(
        // modify wallet to display error if unavailable but displayUnavailable is set
        displayUnavailable && !walletAvailable ? _objectSpread(_objectSpread({}, wallet), {}, {
          getInterface: function () {
            var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    throw new Error(walletUnavailableMessage ? walletUnavailableMessage(wallet) : defaultWalletUnavailableMsg(wallet));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            function getInterface() {
              return _getInterface.apply(this, arguments);
            }
            return getInterface;
          }()
        }) :
        // otherwise add wallet to list as is
        wallet);
      }
      return acc;
    }, []);
    if (wallets.length) {
      var moreThanOneWallet = wallets.length > 1;
      // if more than one wallet, then remove detected wallet
      var formattedWallets = wallets.filter(function (wallet) {
        var label = wallet.label;
        return !(label === ProviderLabel.Detected && moreThanOneWallet);
      })
      // then map to the WalletModule interface
      .map(function (_ref3) {
        var label = _ref3.label,
          getIcon = _ref3.getIcon,
          getInterface = _ref3.getInterface;
        return {
          label: label,
          getIcon: getIcon,
          getInterface: getInterface
        };
      })
      // default sort by alphabetical
      .sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });
      return sort ? sort(formattedWallets) : formattedWallets;
    }
    return [];
  };
}
export default injected;